<template>
  <div class="quiz-bottom" style="margin-top: 6px">
    <!-- <div
      style="
        background: #f7f7f9;
        width: 100%;
        color: #999999;
        font-size: 14px;
        padding: 10px 26px;
        text-align: left;
      "
    >
      <span>{{ title }}</span>
    </div> -->
    <a-textarea
      v-model="text"
      :maxLength="200"
      class="quiz-textarea"
      style="
        resize: none;
        background: #f7f7f9;
        border: none;
        padding: 10px 26px;
      "
      placeholder="请向辅导老师描述您的问题。"
      :rows="4"
    />
    <div
      v-if="showBottom"
      style="
        height: 60px;
        background: #f7f7f9;
        display: flex;
        align-items: center;
        padding: 0 25px;
      "
      :style="'width:'+quizWidth"
    >
      <a-button type="danger" style="background:var(--themeColor);border:1px solid var(--themeColor)" @click="$emit('click', text)"> 提问 </a-button>
      <div style="display: flex; margin-left: auto; align-items: center">
        <span style="color: #999999; margin-right: 30px"
          >{{ text.length ? text.length : 0 }}/200</span
        >

        <a-popconfirm
          title="确定要删除提问信息?"
          ok-text="确定"
          cancel-text="取消"
          @confirm="confirm"
          @cancel="cancel"
        >
          <a-icon style="margin-right: 30px; cursor: pointer" type="delete" />
        </a-popconfirm>
        <!-- <a-icon style="cursor: pointer" type="more" /> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "",
    };
  },
  props: {
    title: {
      type: String,
      default: "请向辅导老师描述您的问题。",
    },
    showBottom: {
      type: Boolean,
      default: true,
    },
    quizWidth:{
      type:String,
      default:'100%'
    }
  },
  methods: {
    btnClick() {
      this.text = "";
    },
    confirm(e) {
      console.log(e);
      this.btnClick();
    },
    cancel(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>